
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
 SERVICE_EMAIL_CONFIRMATION, SERVICE_EMAIL_CONFIRMATION_SUCCESS, SERVICE_EMAIL_CONFIRMATION_FAIL
} from "./actionTypes";
import {
  serviceEmailConfirmationFail, serviceEmailConfirmationSuccess
} from "./actions";

import {
   serviceEmailConfirmationUrl
} from "../../helpers/fakebackend_helper";
function* onServiceEmailConfirmation({payload: {token}}) {
  try {
    const response = yield call(serviceEmailConfirmationUrl, token);
    yield put(serviceEmailConfirmationSuccess(response.message))
  } catch (error) {
    yield put(serviceEmailConfirmationFail(error.response.data.message));
  }
}

function* serviceEmailConfirmationSaga() {
  yield takeEvery(SERVICE_EMAIL_CONFIRMATION, onServiceEmailConfirmation);
}

export default serviceEmailConfirmationSaga;

